import styled from 'styled-components'

const Container = styled.div`
  height: 100%;
`
const SubHeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const SubHeader = styled.div`
  font-size: 14px;
  color: var(--color-text-secondary);
`

export { Container, SubHeaderWrap, SubHeader }
